import type InstallmentPlan from "@/types/InstallmentPlan";
import formatCurrency from "@/utils/formatCurrency";

/** How the buyer reads an Installment plan when choosing it. */
export function installmentPlanTitle(plan: InstallmentPlan): string {
  const installment = `${plan.installments}x de ${formatCurrency(plan.installment_value / 100)}`;

  return plan.interest_free ? `${installment} sem juros` : `${installment} (${formatCurrency(plan.amount / 100)})`;
}
